module.exports = __webpack_public_path__ + "static/media/teacher_icon.a084524b.svg";